var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
// require('bootstrap-five');
// import * as Popper from "@popperjs/core"
// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
// require('bootstrap-five/js/dist/collapse');
require('bootstrap-five/js/dist/dropdown');
// require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/scrollspy');
require('webticker/jquery.webticker.js');
require('bootstrap-five/js/dist/tab');
// require('bootstrap-five/js/dist/tooltip');
require('magnific-popup');
var cookie = require('js-cookie');
require('tablesorter');
require('datatables.net-dt');

import Swiper from 'swiper/bundle';

// import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// import bodymovin from 'lottie-web';
require('jquery-countdown');
import Mmenu from 'mmenu-js';

// const scryll = require("scryll");
import scryll from "scryll";

// require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');


// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    /* $('a[href^="#"]').on('click', function(event) {
        event.preventDefault(); // Prevent default anchor click behavior

        var target = this.hash; // Get the target section
        var headerHeight = $(".fixed-header").outerHeight(); // Get the height of the fixed header

        // Animate the scroll to the target section with offset
        $('html, body').animate({
            scrollTop: $(target).offset().top + headerHeight + 300(); // Adjust for header height
            alert(headerHeight)

        }, 800, function() {
            window.location.hash = target ; // Update the URL hash
        });
        // alert(headerHeight)
    }); */

    $('.page-scroll').bind('click', function (event) {
        var $anchor = $(this);

        $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top - 250
        }, 750, 'easeInOutExpo');

        event.preventDefault();
    });

    initAjaxJS();

    if ($('#cookieAcceptBar').length) {
        var tickerSpeed = $("#webTicker").attr("data-speed");

        $('#webTicker').webTicker({
            speed:tickerSpeed
        });

        $('.btn-open').on('click', function() {
            $(this).prev('.content' ).slideToggle( 'slow' );
            $(this).find('.btn-more-icon' ).toggleClass( 'd-none' );
        });
    };

    if ($('#clock').length) {
        //YYYY/M/D
        $('#clock').countdown('2025/3/24', function(event) {
            $(this).html(event.strftime('' +
                '<div class="box"><h3>%m</h3><p>Months</p></div><div class="box"><h3>%n</h3><p>Days</p></div><div class="box"><h3>%H</h3><p>Hours</p></div>'
            ));
        });
    }





    $('#btn-menu').on('click', function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    });

    // Add new click handler to hide button
    $('#day-tab').on('click', function() {
        $("#btn-legend").show();  // or use $(this).addClass('d-none'); for Bootstrap
    });
    $('#week-tab').on('click', function() {
        $("#btn-legend").hide();  // or use $(this).addClass('d-none'); for Bootstrap
    });

    var announcementHeight = $(".announcements").outerHeight();

    $(".fixed-header").css("top", announcementHeight );
    //tabbed url
    toggleProgramLegendVisibility();
    if (location.hash.slice(0, 2) == "#!") {
        toggleProgramLegendVisibility();
        $("[data-bs-target='#" + location.hash.slice(2) + "']").trigger('click');
    }
    $("[data-bs-toggle='tab']").on('shown.bs.tab', function(e) {
        var hash = $(e.target).data('bs-target');
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
        toggleProgramLegendVisibility();
    });

    $(document).on("scroll",function(){

        if ($(document).scrollTop() > 60){
            $(".header-logos").addClass("header-shrink");
        }else {
            $(".header-logos").removeClass("header-shrink");
        }

        if ($(document).scrollTop() > 0){
            $(".fixed-header").css("top", 0 );
        }else {
            $(".fixed-header").css("top", announcementHeight );
        }

        if ($(document).scrollTop() > 300){
            $(".btn-top").css("opacity", 1);
        }else{
            $(".btn-top").css("opacity", 0);
        }
        // console.log($("#top").offset().top);
    });

    if ($('.pop-image').length) {
        $('.pop-image').magnificPopup({
            type: 'image',
            disableOn: function() { // don't use a popup for mobile
                if( $(window).width() < 767 ) {
                    return false;
                }
                return true;
            },
            gallery: {
                enabled: true
            },
            callbacks: {
                buildControls: function() {
                    // re-appends controls inside the main container
                    this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                }
            }
        });
        if( $(window).width() < 767 ) {
            $.magnificPopup.close()
        }
    }



    // alert(offsetSize);
    var resize_timeout;
    $(window).on('resize orientationchange', function(){
        clearTimeout(resize_timeout);

        resize_timeout = setTimeout(function(){
            $(window).trigger('resized');
        }, 250);
    });


    if ($('#delegates-table').length) {
        $('#delegates-table').DataTable({
            pageLength: 25,
            order: [[0, 'asc']],
            responsive: true,
            language: {
                search: "Search:",
                searchPlaceholder: "",
                lengthMenu: "Show _MENU_ delegates per page",
                info: "Showing _START_ to _END_ of _TOTAL_ delegates",
                paginate: {
                    first: "First",
                    last: "Last",
                    next: "Next",
                    previous: "Previous"
                }
            },
            columns: [
                { searchable: true, className: 'nowrap' }, // Name
                { searchable: true }, // Position
                { searchable: true }, // Department
                { searchable: true }, // Organisation
                { searchable: true}, // Country
                { 
                    searchable: true,
                    render: function(data, type, row) {
                        if (type === 'display') {
                            return '<a type="button" class="masked-email btn btn-table" data-email="' + data + '">Reveal</a>';
                        }
                        return data;
                    }
                }  // Email
            ],
            drawCallback: function() {
                $('.masked-email').on('click', function(e) {
                    e.preventDefault();
                    var email = $(this).data('email');
                    $(this).replaceWith('<a href="mailto:' + email + '" class="btn-table nowrap"><img src="/img/site/icons/mail-wh.svg" alt="Email" class="me-2"> ' + email + '</a>');
                });
            }
        });
    }





    if ($('.tablesorter').length) {

        var offsetSize;
        if ($(window).width() > 992) {
            offsetSize = 175;
        }else{
            offsetSize = $(".fixed-header").height();
        }

        $('<thead></thead>').prependTo('.tablesorter').append($('.tablesorter tr:first'));
        $('<input class="search form-control form-control--search table-search mb-4" placeholder="Enter Keyword" type="search" data-column="all">').insertBefore('.tablesorter');
        $('.tablesorter').wrap('<div class="table-responsive flip-table--"></div>');

        $('.tablesorter').tablesorter({
                widgets: ['filter', 'zebra', 'stickyHeaders'],
                widgetOptions : {
                    // filter_anyMatch replaced! Instead use the filter_external option
                    // Set to use a jQuery selector (or jQuery object) pointing to the
                    // external filter (column specific or any match)
                    filter_external : '.search',
                    // add a default type search to the first name column
                    filter_defaultFilter: { 1 : '~{query}' },
                    // include column filters
                    filter_columnFilters: false,
                    filter_placeholder: { search : 'Search...' },
                    filter_saveFilters : true,
                    filter_reset: '.reset',
                    zebra : [ "normal-row", "alt-row"  ],
                    stickyHeaders_offset : offsetSize,
                    //  stickyHeaders_attachTo : '.copysticky' // $('.wrapper') jQuery object can also be used
                    // stickyHeaders_attachTo : '.copy', // or $('.wrapper')
                    // stickyHeaders_xScroll : true,
                }
        });


        $(window).on('resized', function() {

            if ($(window).width() > 992) {
                offsetSize = 175;
            }else{
                offsetSize = $(".fixed-header").height();
            }

            $('.tablesorter')[0].config.widgetOptions.stickyHeaders_offset = offsetSize;
            $('.tablesorter').trigger('stickyHeadersUpdate');


            // $('.tablesorter').tablesorter({
            //     widgetOptions : {
            //         stickyHeaders_offset : offsetSize,
            //     }
            // });
        });

         //Remove right click on table
        $(".tablesorter").on("contextmenu",function(e){
            return false;
        });



        // dual scroll
        const myScryll = scryll('.tablesorter-sticky-wrapper', '.table-responsive', {
            direction: "horizontal",
        });

        myScryll.init();

        $('td').removeAttr('style');

        $("table.tablesorter-email tbody tr td:last-child").each(function() {
            var email = $(this).text();
            $(this).html('<a href="mailto:' + email + '">' + email + '</a>');
        });

    }else{
        $('.search-control').addClass('d-none');
    }


        //Add smooth scroll to sections with header offset



    // init Swiper:
    if($('.sponsorCarousel').length){
        const sponsorSwiper = new Swiper('.sponsorCarousel', {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            observer: true,
            observeParents: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                480: {
                    slidesPerView: 2,
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 3,
                },
                // when window width is >= 640px
                1024: {
                    slidesPerView: 4,
                },

            },
        });
    }

    if($('.heroSwiper').length){
        const heroSwiper = new Swiper('.heroSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
    if($('.contentSwiper').length){
        const contentSwiper = new Swiper('.contentSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
    if($('.accommodationSwiper').length){
        const accommodationSwiper = new Swiper('.accommodationSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

});


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {
    cookiesPolicyBar();
}

function toggleProgramLegendVisibility() {
    if (location.hash.slice(2) == 'speakers') {
        // $('#program-speakers-heading').removeClass('d-none');
        $('#program-speakers-heading').addClass('d-none d-md-block');

        $('#program-legend').addClass('d-none');
    } else {
        $('#program-speakers-heading').addClass('d-none');
        $('#program-speakers-heading').removeClass('d-md-block');

        $('#program-legend').removeClass('d-none');
    }
}

// Accept cookies
function cookiesPolicyBar() {
    // Check cookie
    if (cookie.get('APAIE_Announcement') != "active") {
        $('#cookieAcceptBar').show();

        $(window).on('scroll', function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 40) { /* scroll top menu out of view */
                $('.mm-panels').css('margin-top', 0);

            } else {
                $('.mm-panels').css('margin-top', 40);
            }
        });

    }else{
        $('.mm-panels').css('margin-top', 0);

    }



    //Assign cookie on click
    $('.cookieAcceptBarConfirm').on('click', function() {
        cookie.set('APAIE_Announcement', 'active', { expires: 1 }); // cookie will expire in one day
        $('#cookieAcceptBar').slideToggle( "fast" );
        $('.mm-panels').css('margin-top', 0);

        $(window).on('scroll', function() {
            var scroll = $(window).scrollTop();

            $('.mm-panels').css('margin-top', 0);

        });

    });
}

const mmenu = new Mmenu('#mob-menu', {
    'extensions': [
        "pagedim-black"
    ],
}, {
    // configuration
    offCanvas: {
        page: {
                selector: '#offcanvas'
        }
    },
    classNames: {
        selected: "active"
    }
});

const mmenuApi = mmenu.API;
mmenuApi.bind('open:after', function(){
    $('.btn-menu').addClass('open').attr('href','#offcanvas');
});
mmenuApi.bind('close:after', function(){
    $('.btn-menu').removeClass('open').attr('href','#mob-menu');
});